import { render } from "./PaymentDetailsCard.vue?vue&type=template&id=2fb74328&scoped=true&ts=true"
import script from "./PaymentDetailsCard.vue?vue&type=script&lang=ts"
export * from "./PaymentDetailsCard.vue?vue&type=script&lang=ts"

import "./PaymentDetailsCard.vue?vue&type=style&index=0&id=2fb74328&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb74328"]])

export default __exports__